import React, { Fragment } from 'react';
import { connect } from 'react-redux';

// Components
import ListTile from './ListTile';

// utils
import { decideCardArtUrl } from 'src/universal/utils/cardColorChoices';
import parseArrayToObject from 'src/universal/utils/parseArrayToObject';

// redux
import { getCardColorInfoList } from 'src/universal/redux/cardColors';
import { hasPznDataArrived } from 'src/universal/redux/pznData';

// tracking
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';

const CardDisplay = ({ card, colorInfoList, filteredCards }) => {
  const { shortName, isInCurrentFilter } = card || {};
  const bauCardArtUrl = card?.appAssets?.cardArt ?? '';
  const colorInfo = colorInfoList.find(c => c.shortName === card.shortName);
  const cardArtUrl = decideCardArtUrl(bauCardArtUrl, colorInfo);
  return (
    <ListTile
      isInCurrentFilter={isInCurrentFilter}
      card={card}
      cardArtUrl={cardArtUrl}
      shortName={shortName}
      filteredCards={filteredCards}
    />
  );
};

const CardTileMobile = ({
  cardList = [],
  colorInfoList,
  pageData,
  pznArrived,
  filteredCards
}) => {
  const listTilesDTM = parseArrayToObject(
    pageData.mobileTilesExtended.listTileDTM,
    'key'
  );

  return (
    pznArrived && (
      <div className={'card-tile-wrap-mobile'}>
        <div className={'card-summary-narrow'}>
          {cardList.map((item, index) => {
            const dtmProductName = item?.dtmProductName || '';
            const impressionEvent = listTilesDTM.listImpression;

            return (
              <Fragment key={index}>
                <CardDisplay
                  card={item}
                  colorInfoList={colorInfoList}
                  filteredCards={filteredCards}
                />
                <LazyScrollMetricTracker
                  scrollDtm={{
                    ...impressionEvent,
                    eventAsset: `${impressionEvent.eventAsset}${dtmProductName}`
                  }}
                  key={dtmProductName}
                />
              </Fragment>
            );
          })}
        </div>
      </div>
    )
  );
};

const mapStateToProps = state => ({
  colorInfoList: getCardColorInfoList(state),
  pznArrived: hasPznDataArrived(state)
});

export default connect(mapStateToProps)(CardTileMobile);
